import keyBy from "lodash/keyBy";
import * as types from "../actions/actionTypes";
import intialState from "./initialState";

const handles = {
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state, { gameConfigs }) => ({
    ...state,
    map: { ...state.map, ...keyBy(gameConfigs, "_id") },
  }),
};

export default function gameConfigReducer(
  state = intialState.gameConfigurations,
  action,
) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
